import React, { useState } from "react";
import { useEffect, Fragment } from 'react';
import {
  Button,
  Card,
  CardHeader,
  Container, Modal,
  Row, Progress,
  Col, FormGroup, Input,
} from "reactstrap";
import { NavLink as NavLinkRRD, Link, useHistory } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import { Form, Field } from "react-final-form";
import dataProvider from 'dataProvider';
import auth from "authProvider";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";
import { Chart } from "react-google-charts";
import DatePicker from "react-multi-date-picker"
import transition from "react-element-popper/animations/transition"
import { AiOutlineFieldTime } from "react-icons/ai";

const getColumnData = async (data) => {
  return new Promise(async (resolve, reject) => {
    let column = [["Element", "category", { role: "style" }, { role: 'annotation' }, { role: 'annotation' }]];
    data.map((val, index) => {
      column.push([val.category, val.count, val.color, val.count, val.category]);
      if (index === (data.length - 1)) {
        resolve(column);
      }
    })
  })
}

const Reports = (props) => {
  const history = useHistory();
  let token = localStorage.getItem('token');
  const [initialopen, setInitialopen] = useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [chartData, setChartData] = useState(false);
  const [range, setRange] = useState(new Date())
  const [column, setColumn] = useState([["Element", "category", { role: "style" }, { role: 'annotation' }, { role: 'annotation' }]])
  const [flag, setFlag] = useState(false);
  const [workorder, setWorkorder] = useState({ type: 'weekly', start: false, end: false });
  const [category, setCategory] = useState({ type: 'weekly', start: false, end: false });



  const onLogout = () => {
    auth.logout();
    history.push("/")
  }



  useEffect(() => {
    dataProvider.getReport({ workorder: workorder, category: category, token: token })
      .then(async ({ data }) => {
        setChartData(data);
        if (data.WorkOrderCountByCat && data.WorkOrderCountByCat.length > 0) {
          let columnData = await getColumnData(data.WorkOrderCountByCat);
          setColumn(columnData)
        }
        else {
          const data = [
            ["Element", "category", { role: "style" }],
            ["", 0, ''], // RGB value
          ];
          setColumn(data)
          setInitialopen(true)
        }

      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      })
  }, [props]);

  const onSubmit = values => {
  };

  const Onchange_workorderType = (range) => {
    let arr = {
      'start': workorder.start,
      'end': workorder.end,
      'type': range
    };
    setWorkorder(arr)
    setFlag(!flag);
  }
  const Onchange_workorderrange = (values) => {
    let arr;
    if (workorder.type == 'monthly') {
      arr = {
        'start': values?.format('MM/DD/YYYY'),
        'end': values?.format('MM/DD/YYYY'),
        'type': workorder.type
      };
    }
    else {
      arr = {
        'start': values[0]?.format('MM/DD/YYYY'),
        'end': values[1]?.format('MM/DD/YYYY'),
        'type': workorder.type
      };
    }
    setWorkorder(arr);
    setFlag(!flag);
  }

  const Onchange_categoryType = (values) => {
    let arr = {
      'start': category.start,
      'end': category.end,
      'type': values
    };
    setCategory(arr)
    setFlag(!flag);
  }

  const Onchange_categoryrange = (values) => {
    let arr;
    if (category.type == 'monthly') {
      arr = {
        'start': values?.format('MM/DD/YYYY'),
        'end': values?.format('MM/DD/YYYY'),
        'type': category.type
      };
    }
    else {
      arr = {
        'start': values[0]?.format('MM/DD/YYYY'),
        'end': values[1]?.format('MM/DD/YYYY'),
        'type': category.type
      };
    }
    setCategory(arr)
    setFlag(!flag);
  }

  const data = [
    ["Task", "Count"],
    ["Normal", chartData?.prorityCount?.normal],
    ["Urgent", chartData?.prorityCount?.urgent],
  ];

  const options = {
    pieHole: 0.86,
    is3D: false,
    fontSize: 10,
    fontWeight: 'bold',
    chartArea: {
      left: "5%",
      top: "2%",
      height: "90%",
      width: "85%"
    },
    legend: {
      position: 'labeled'
    },
  };

  const optionscolumn = {
    chartArea: { width: "100%" },
    // height: 200,
    width: 700,
    // legend: 'none',
    bar: { groupWidth: "85%" },
    legend: { position: "top" },
    annotations: {
      style: 'line',
      stem: {
        color: 'transparent'
      },
      textStyle: {
        fontName: 'sans-serif',
        fontSize: 16,
        color: 'black',
        // fontWeight: 'bold',
        // auraColor: 'transparent',
        opacity: 0.9
        ,
        textStyle: 'none',
        textStyle: { align: 'none' }
      },
      alwaysOutside: true
    },
    legend: {
      position: 'labeled'
    },
    // seriesType: 'bars',
    vAxis: {
      // textPosition: 'in',
      gridlines: {
        color: 'transparent',

      },
    },

    hAxis:
    {
      textPosition: 'none',
      textColor: 'none',
      direction: -1,
    },
  };

  const Filter_ondate = () => {
    dataProvider.getReport({ workorder: workorder, category: category, token: token })
      .then(async ({ data }) => {
        setChartData(data);
        if (data.WorkOrderCountByCat && data.WorkOrderCountByCat.length > 0) {
          let columnData = await getColumnData(data.WorkOrderCountByCat);
          setColumn(columnData)
        }
        else {
          const data = [
            ["Element", "category", { role: "style" }],
            ["", 0, ''], // RGB value
          ];
          setColumn(data)
          // setInitialopen(true)
        }
      })
      .catch(error => {
        if (error?.response?.data?.expire === true) {
          setModalOpen(true)
        }
      })
  }


  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <h1 className="mb-0" style={{ color: 'white', marginLeft: 10 }}>REPORTS</h1>
          </div>
        </Container>
      </div>
      <Container className="mt--8" fluid>
        <Row className="mt-4">
          <Col className="mb-5 mb-xl-0" xl="8">
            <Card className="shadow" style={{ borderRadius: '20px', padding: 20 }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', padding: '0px', flexDirection: 'row', justifyContent: 'space-between', borderRadius: 20 }} >
                <div style={{ alignContent: 'flex-start' }}><h3 style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>Work orders</h3></div>
                <div style={{ backgroundColor: 'transparent', flexDirection: 'row', display: 'flex', fontSize: '0.625rem', borderColor: '#ccc' }}>
                  <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit }) => (
                      <form
                        onSubmit={async event => {
                          handleSubmit(event)
                        }}
                      >
                        <Row style={{ display: 'flex', flexDirection: 'row' }}>
                          <Col lg="5">
                            <FormGroup>
                              <Field >
                                {({ input, meta, error }) => (
                                  <div>
                                    <Input type="select" onChange={(e) => Onchange_workorderType(e.target.value)} style={{ padding: 0, height: '35px', borderRadius: 8 }}>
                                      <option selected={'weekly'} value='weekly'>Weekly Reports</option>
                                      <option value='monthly'>Monthly Reports</option>
                                      <option value='custom'>Custom Reports</option>
                                    </Input>
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                          {workorder.type === 'weekly' ?
                            <Col lg="4" style={{ display: 'flex', flexDirection: 'row' }}>
                              <div style={{ position: 'absolute', top: 8, left: 20 }}><IcomoonReact iconSet={iconSet} color="#77665c" size={16} icon="date-picker" /></div>
                              <div>
                                <DatePicker
                                  buttons={true}
                                  style={{
                                    height: "8px",
                                    borderRadius: "4px",
                                    fontSize: "10.5px",
                                    fontWeight: 600,
                                    padding: "15px 0px 17px 20px",
                                    width: 155,
                                    border: '1px solid #ccc ',
                                    color: '#917f92',
                                    borderRadius: 9
                                  }}
                                  value={range}
                                  onChange={(value) => Onchange_workorderrange(value)}
                                  format='DD/MM/YYYY'
                                  range
                                  weekPicker
                                  hideOnScroll
                                  animations={[
                                    transition({
                                      from: 35,
                                      transition: "all 400ms cubic-bezier(0.335, 0.010, 0.030, 1.360)",
                                    }),
                                  ]}
                                />
                              </div>
                            </Col> : workorder.type === 'monthly' ?
                              <Col lg="4">
                                <div>
                                  <DatePicker
                                    style={{
                                      height: "8px",
                                      borderRadius: "4px",
                                      fontSize: "10.5px",
                                      fontWeight: 600,
                                      padding: "15px 0px 17px 20px",
                                      width: 155,
                                      border: '1px solid #ccc ',
                                      color: '#917f92',
                                      borderRadius: 9
                                    }}
                                    value={range}
                                    onChange={(value) => Onchange_workorderrange(value)}
                                    format='MMM YYYY'
                                  />
                                </div>
                              </Col> :
                              <Col lg="4">
                                <div>
                                  <DatePicker
                                    style={{
                                      height: "8px",
                                      borderRadius: "4px",
                                      fontSize: "10.5px",
                                      fontWeight: 600,
                                      padding: "15px 0px 17px 20px",
                                      width: 155,
                                      border: '1px solid #ccc ',
                                      color: '#917f92',
                                      borderRadius: 9
                                    }}
                                    value={range}
                                    range
                                    onChange={(value) => Onchange_workorderrange(value)}
                                    format='DD/MM/YYYY'
                                    animations={[
                                      transition({
                                        from: 35,
                                        transition: "all 400ms cubic-bezier(0.335, 0.010, 0.030, 1.360)",
                                      }),
                                    ]}
                                  />
                                </div>
                              </Col>}
                          <Col lg="2">
                            <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'row' }}>
                              <Button onClick={() => Filter_ondate()} style={{ backgroundColor: 'white', display: 'flex', fontSize: '0.625rem', paddingLeft: '2px', borderRadius: '10PX', borderColor: 'rgb(114 218 249)', color: 'rgb(114 218 249)' }}>
                                <IcomoonReact iconSet={iconSet} style={{ marginRight: 2, marginTop: 2 }} color="rgb(114 218 249)" size={12} icon="filter" />FILTER</Button>{' '}
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}
                  />
                </div>
              </CardHeader>
              <hr class="my-3"></hr>
              <div style={{ flexDirection: 'row', display: 'flex', paddingLeft: 20 }}>
                <div style={{ display: 'flex', fontWeight: 'bold' }}><label>{chartData?.WorkOrderCountByDate?.pending} </label></div>
                <div style={{ display: 'flex', paddingLeft: 20, fontSize: '0.8rem', color: '#ccc' }}><label>Pending</label></div>
              </div>
              <div style={{ paddingLeft: 20 }}>
                <Progress color="danger" value={chartData?.WorkOrderCountByDate?.pending} />
              </div>
              <div style={{ flexDirection: 'row', display: 'flex', paddingLeft: 20 }}>
                <div style={{ display: 'flex', fontWeight: 'bold' }}><label>{chartData?.WorkOrderCountByDate?.overdue}</label></div>
                <div style={{ display: 'flex', paddingLeft: 20, fontSize: '0.8rem', color: '#ccc' }}><label>Over due</label></div>
              </div>
              <div style={{ paddingLeft: 20 }}>
                <Progress color="info" value={chartData?.WorkOrderCountByDate?.overdue} />
              </div>
              <div style={{ flexDirection: 'row', display: 'flex', paddingLeft: 20 }}>
                <div style={{ display: 'flex', fontWeight: 'bold' }}><label>{chartData?.WorkOrderCountByDate?.inprogress}</label></div>
                <div style={{ display: 'flex', paddingLeft: 20, fontSize: '0.8rem', color: '#ccc' }}><label>Inprogress</label></div>
              </div>
              <div style={{ paddingLeft: 20 }}>
                <Progress color="success" value={chartData?.WorkOrderCountByDate?.inprogress} />
              </div>
              <div style={{ flexDirection: 'row', display: 'flex', paddingLeft: 20 }}>
                <div style={{ display: 'flex', fontWeight: 'bold' }}><label>{chartData?.WorkOrderCountByDate?.assigned}</label></div>
                <div style={{ display: 'flex', paddingLeft: 20, fontSize: '0.8rem', color: '#ccc' }}><label>Assigned</label></div>
              </div>
              <div style={{ paddingLeft: 20 }}>
                <Progress color="warning" value={chartData?.WorkOrderCountByDate?.assigned} />
              </div>
              <div style={{ flexDirection: 'row', display: 'flex', paddingLeft: 20 }}>
                <div style={{ display: 'flex', fontWeight: 'bold' }}><label>{chartData?.WorkOrderCountByDate?.completed}</label></div>
                <div style={{ display: 'flex', paddingLeft: 20, fontSize: '0.8rem', color: '#ccc' }}><label>Completed</label></div>
              </div>
              <div style={{ paddingLeft: 20 }}>
                <Progress color="success" value={chartData?.WorkOrderCountByDate?.completed} />
              </div>
              <div style={{ flexDirection: 'row', display: 'flex', paddingLeft: 20 }}>
                <div style={{ display: 'flex', fontWeight: 'bold' }}><label>{chartData?.WorkOrderCountByDate?.reopened}</label></div>
                <div style={{ display: 'flex', paddingLeft: 20, fontSize: '0.8rem', color: '#ccc' }}><label>Reopened</label></div>
              </div>
              <div style={{ paddingLeft: 20 }}>
                <Progress color="success" value={chartData?.WorkOrderCountByDate?.reopened} />
              </div>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow" style={{ borderRadius: '20px' }}>
              <CardHeader className="border-0" style={{ borderRadius: '20px' }}>
                <Row className="align-items-center">
                  <div className="col">
                    <h3 style={{ marginLeft: 12, fontWeight: 'bold' }} className="mb-0">Priority</h3>
                    <hr class="my-3"></hr>
                  </div>
                </Row>
              </CardHeader>
              <Chart
                chartType="PieChart"
                data={data}
                options={options}
              />
            </Card>
          </Col>
        </Row>
        <Row className="mt-5" >
          <Col xl="4">
            <Card className="shadow" style={{ borderRadius: '20px' }}  >
              <CardHeader className="border-0" style={{ borderRadius: '20px' }}>
                <Row className="align-items-center">
                  <div className="col" >
                    <h3 style={{ marginLeft: 8, fontWeight: 'bold', fontSize: '1.2rem' }} className="mb-0">NEW WORK ORDER</h3>
                    <hr class="my-3"></hr>
                  </div>
                </Row>
              </CardHeader>
              <label style={{ marginLeft: 30, fontSize: '0.8rem' }}>Work Orders:</label>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
                <div style={{ display: 'flex' }}><IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="rgb(129 205 255)" size={30} icon="add-photos" /></div>
                <div style={{ display: 'flex', fontSize: '1.6rem' }}><label style={{ fontWeight: 'bold' }}>{chartData?.WorkOrderCount?.new ? chartData?.WorkOrderCount?.new : 0}</label></div>
              </div>
              <div style={{ display: 'flex', fontSize: '1.5rem', marginBottom: 5, flexDirection: 'row' }}>
                <div style={{ color: 'rgb(114 218 249)', marginLeft: 24 }}><AiOutlineFieldTime /></div>
                <div><Link to={{ pathname: '/workorder', params: { show: '0' } }} style={{ fontSize: '0.7rem', marginLeft: 2, color: 'rgb(114 218 249)' }}>All work orders</Link></div>
              </div>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow" style={{ borderRadius: '20px' }}>
              <CardHeader className="border-0" style={{ borderRadius: '20px' }}>
                <Row className="align-items-center">
                  <div className="col">
                    <h3 style={{ marginLeft: 8, fontWeight: 'bold', fontSize: '1.2rem' }} className="mb-0">ASSIGNED</h3>
                    <hr class="my-3"></hr>
                  </div>
                </Row>
              </CardHeader>
              <label style={{ marginLeft: 30, fontSize: '0.8rem' }}>Work Orders:</label>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
                <div style={{ display: 'flex' }}><IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10, backgroundColor: 'rgb(255 170 0)', borderRadius: 15, padding: 5 }} color="white" size={30} icon="assigned-technician" /></div>
                <div style={{ display: 'flex', fontSize: '1.5rem' }}><label style={{ fontWeight: 'bold' }}>{chartData?.WorkOrderCount?.assigned ? chartData?.WorkOrderCount?.assigned : 0}</label></div>
              </div>
              <div style={{ display: 'flex', fontSize: '1.5rem', marginBottom: 5, flexDirection: 'row' }}>
                <div style={{ color: 'rgb(114 218 249)', marginLeft: 24 }}><AiOutlineFieldTime /></div>
                <div><Link to={{ pathname: '/workorder', params: { status: 'assigned' } }} style={{ fontSize: '0.7rem', marginLeft: 2, color: 'rgb(114 218 249)' }}>All work orders</Link></div>
              </div>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow" style={{ borderRadius: '20px' }}>
              <CardHeader className="border-0" style={{ borderRadius: '20px' }}>
                <Row className="align-items-center">
                  <div className="col">
                    <h3 style={{ marginLeft: 8, fontWeight: 'bold', fontSize: '1.2rem' }} className="mb-0">PENDING</h3>
                    <hr class="my-3"></hr>
                  </div>
                </Row>
              </CardHeader>
              <label style={{ marginLeft: 30, fontSize: '0.8rem' }}>Work Orders:</label>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ width: 30, height: 30, border: '1px solid red', borderRadius: 15, backgroundColor: 'red' }}>
                    <label style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontWeight: 'bold' }}>!</label>
                  </div>
                  <div><label style={{ display: 'flex', flexDirection: 'row', fontWeight: 'bold', marginLeft: 4, fontSize: '1.6rem' }}>{chartData?.WorkOrderCount?.pending ? chartData?.WorkOrderCount?.pending : 0}</label></div>
                </div>
              </div>
              <div style={{ display: 'flex', fontSize: '1.5rem', marginBottom: 5, flexDirection: 'row' }}>
                <div style={{ color: 'rgb(114 218 249)', marginLeft: 24 }}><AiOutlineFieldTime /></div>
                <div><Link to={{ pathname: '/workorder', params: { status: 'pending' } }} style={{ fontSize: '0.7rem', marginLeft: 2, color: 'rgb(114 218 249)' }}>All work orders</Link></div>
              </div>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xl="4">
            <Card className="shadow" style={{ borderRadius: '20px' }}>
              <CardHeader className="border-0" style={{ borderRadius: '20px' }}>
                <Row className="align-items-center">
                  <div className="col">
                    <h3 style={{ marginLeft: 8, fontWeight: 'bold', fontSize: '1.2rem' }} className="mb-0">COMPLETED</h3>
                    <hr class="my-3"></hr>
                  </div>
                </Row>
              </CardHeader>
              <label style={{ marginLeft: 30, fontSize: '0.8rem' }}>Work Orders:</label>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
                <div style={{ display: 'flex' }}><IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10, backgroundColor: 'rgb(66 152 10)', borderRadius: 20, padding: 5 }} color="white" size={30} icon="completed-task" /></div>
                <div style={{ display: 'flex', fontSize: '1.6rem' }}><label style={{ fontWeight: 'bold' }}>{chartData?.WorkOrderCount?.completed ? chartData?.WorkOrderCount?.completed : 0}</label></div>
              </div>
              <div style={{ display: 'flex', fontSize: '1.5rem', marginBottom: 5, flexDirection: 'row' }}>
                <div style={{ color: 'rgb(114 218 249)', marginLeft: 24 }}><AiOutlineFieldTime /></div>
                <div><Link to={{ pathname: '/workorder', params: { status: 'completed' } }} style={{ fontSize: '0.7rem', marginLeft: 2, color: 'rgb(114 218 249)' }}>All work orders</Link></div>
              </div>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow" style={{ borderRadius: '20px' }}>
              <CardHeader className="border-0" style={{ borderRadius: '20px' }}>
                <Row className="align-items-center">
                  <div className="col">
                    <h3 style={{ marginLeft: 8, fontWeight: 'bold', fontSize: '1.2rem' }} className="mb-0">REOPENED</h3>
                    <hr class="my-3"></hr>
                  </div>
                </Row>
              </CardHeader>
              <label style={{ marginLeft: 30, fontSize: '0.8rem' }}>Work Orders:</label>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
                <div style={{ display: 'flex' }}><IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10, backgroundColor: 'rgb(33 136 204)', borderRadius: 20, padding: 5 }} color="white" size={30} icon="Icon" /></div>
                <div style={{ display: 'flex', fontSize: '1.5rem' }}><label style={{ fontWeight: 'bold' }}>{chartData?.WorkOrderCount?.reopened ? chartData?.WorkOrderCount?.reopened : 0}</label></div>
              </div>
              <div style={{ display: 'flex', fontSize: '1.5rem', marginBottom: 5, flexDirection: 'row' }}>
                <div style={{ color: 'rgb(114 218 249)', marginLeft: 24 }}><AiOutlineFieldTime /></div>
                <div><Link to={{ pathname: '/workorder', params: { status: 'reopened' } }} style={{ fontSize: '0.7rem', marginLeft: 2, color: 'rgb(114 218 249)' }}>All work orders</Link></div>
              </div>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xl="12">
            <Card className="shadow" style={{ borderRadius: '20px' }}>
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between', borderRadius: 20 }} >
                <div style={{ alignContent: 'flex-start' }}><h3 style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>CATEGORY (WORK ORDERS) </h3></div>
                <div style={{ backgroundColor: 'transparent', flexDirection: 'row', display: 'flex', fontSize: '0.625rem', borderColor: '#ccc' }}>
                  <Form
                    onSubmit={onSubmit}
                    render={({ handleSubmit }) => (
                      <form
                        onSubmit={async event => {
                          handleSubmit(event)
                        }}
                      >
                        <Row style={{ display: 'flex', flexDirection: 'row' }}>
                          <Col lg="5">
                            <FormGroup>
                              <Field>
                                {({ input, meta, error }) => (
                                  <div>
                                    <Input type="select" onChange={(e) => Onchange_categoryType(e.target.value)} style={{ padding: 0, height: '35px', borderRadius: 8 }}>
                                      <option selected={'weekly'} value='weekly'>Weekly Reports</option>
                                      <option value='monthly'>Monthly Reports</option>
                                      <option value='custom'>Custom Reports</option>
                                    </Input>
                                  </div>
                                )}
                              </Field>
                            </FormGroup>
                          </Col>
                          {category.type === 'weekly' ?
                            <Col lg="4" style={{ display: 'flex', flexDirection: 'row' }}>
                              <div style={{ position: 'absolute', top: 8, left: 18 }}><IcomoonReact iconSet={iconSet} color="#77665c" size={16} icon="date-picker" /></div>
                              <div>
                                <DatePicker
                                  buttons={true}
                                  style={{
                                    height: "8px",
                                    borderRadius: "4px",
                                    fontSize: "10.5px",
                                    fontWeight: 600,
                                    padding: "15px 0px 17px 20px",
                                    width: 155,
                                    border: '1px solid #ccc ',
                                    color: '#917f92',
                                    borderRadius: 9
                                  }}
                                  value={range}
                                  onChange={(value) => Onchange_categoryrange(value)}
                                  format='DD/MM/YYYY'
                                  range
                                  weekPicker
                                  hideOnScroll
                                  animations={[
                                    transition({
                                      from: 35,
                                      transition: "all 400ms cubic-bezier(0.335, 0.010, 0.030, 1.360)",
                                    }),
                                  ]}
                                />
                              </div>
                            </Col> : category.type === 'monthly' ?
                              <Col lg="4">
                                <DatePicker
                                  style={{
                                    height: "8px",
                                    borderRadius: "4px",
                                    fontSize: "10.5px",
                                    fontWeight: 600,
                                    padding: "15px 0px 17px 20px",
                                    width: 155,
                                    border: '1px solid #ccc ',
                                    color: '#917f92',
                                    borderRadius: 9
                                  }}
                                  value={range}
                                  onChange={(value) => Onchange_categoryrange(value)}
                                  format='MMM YYYY'
                                />
                              </Col> :
                              <Col lg="4">
                                <div>
                                  <DatePicker
                                    style={{
                                      height: "8px",
                                      borderRadius: "4px",
                                      fontSize: "10.5px",
                                      fontWeight: 600,
                                      padding: "15px 0px 17px 20px",
                                      width: 155,
                                      border: '1px solid #ccc ',
                                      color: '#917f92',
                                      borderRadius: 9
                                    }}
                                    value={range}
                                    hideOnScroll
                                    onChange={(value) => Onchange_categoryrange(value)}
                                    format='DD/MM/YYYY'
                                    range
                                    animations={[
                                      transition({
                                        from: 35,
                                        transition: "all 400ms cubic-bezier(0.335, 0.010, 0.030, 1.360)",
                                      }),
                                    ]}
                                  />
                                </div>
                              </Col>}
                          <Col lg="2">
                            <div style={{ marginLeft: 10 }}>
                              <Button onClick={() => Filter_ondate()} style={{ backgroundColor: 'transparent', color: 'rgb(114 218 249)', fontSize: '0.7rem', border: '1px solid rgb(114 218 249)', borderRadius: 10, display: 'flex', flexDirection: 'row', padding: 7 }}>
                                <IcomoonReact iconSet={iconSet} color="rgb(114 218 249)" size={12} style={{ marginTop: 2, marginLeft: 7, marginRight: 5 }} icon="filter" />FILTER</Button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}
                  />
                </div>
              </CardHeader>
              <div style={{ borderBottom: '2px solid #ebf2f7', margin: '0px 20px 0px 20px' }}></div>
              {column && column.length > 0 ? <div style={{ marginLeft: 30 }}>
                <Chart
                  chartType="ColumnChart"
                  options={optionscolumn}
                  width="100%"
                  height="400px"
                  data={column}
                />
              </div>
                : <Chart
                  chartType="ColumnChart"
                  // options={optionscolumn}
                  width="100%"
                  height="400px"
                  data={column}
                />}
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modalOpen} size="sm">
        <div style={{ color: 'red', padding: 10, marginTop: 10 }}>Your session has expired. Please sign in again.</div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: 20 }}>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white', width: '30%', border: 0 }} type="button">
            LOGOUT
          </Button>
        </div>
      </Modal>
      <Modal isOpen={initialopen} size="sm">
        <div style={{ color: 'red', padding: 10, marginTop: 5, textAlign: 'center' }}>
          No workorder is created on selected date Please Choose another date to Filter</div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
          <Button onClick={() => setInitialopen(false)} style={{ backgroundColor: '#09577C', color: 'white', width: '20%', border: 0 }} type="button">
            OK
          </Button>
        </div>

      </Modal>
    </>
  );
};

export default Reports;

